import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { ToggleSidebar } from '../sidebar.model';
import { SidebarState } from '../sidebar.state';

@Injectable()
export class SidebarService {
  constructor(private store: Store) {
    this.closeSideBarOnMobileWidth();
  }

  public isSidebarCollapsed() {
    return this.store.selectSnapshot(SidebarState.collapsed);
  }

  public setSidebarCollapsed(status: boolean) {
    this.store.dispatch(new ToggleSidebar(status));
  }

  private closeSideBarOnMobileWidth() {
    if (window.innerWidth < 840) this.setSidebarCollapsed(true);
  }
}
